import gql from 'graphql-tag';
import Utils from '../../helpers/utils';

const { secureVariables } = Utils();

export default ({ query, variables }) => {
  query = gql`
    query cmsBlock($identifiers: [String]) {
      cmsBlocks(identifiers: $identifiers) {
        items {
          identifier
          title
          rendered_content {
            content
            inline_style
            inline_js
            page_builder_style
            dynamic_blocks {
              banner_id
              content
            }
          }
        }
      }
    }
  `;
  
  secureVariables(variables);

  return { query, variables };
};
